import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container {
        padding: 0em;
        width: 100%;
        height: 100%;
        gap: 0;
    }

    .body {
        width: 100%;
        height: 100%;
    }

    .header {
        padding: 0.6em;
        background-color: var(--accent-color);
        align-items: center;
        width: 100%;
        justify-content: space-between;
    }

    .header a {
        color: white;
    }

    .controls {
        align-items: center;
    }

    .no-attribution {
        height: 100%;
        padding: 0;
    }

    img {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    .video-wrapper {
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .geo-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 2em;
    }

    video {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: inline-block;
    }

    embed {
        width: 100%;
        height: 100%;
    }

    ds-geo-viewer {
        width: 100%;
        height: 100%;
    }

    .attribution-container {
        padding: 0;
        align-items: center;
    }

    .attribution {
        text-overflow: ellipsis;
        overflow-x: clip;
        font-size: larger;
        color: white;
    }

    .border-left {
        border-left: white solid 2px;
    }

    .description {
        color: white;
        padding-left: 0.5em;
    }

    ds-profile-badge::part(display-name) {
        color: white;
        font-size: large;
    }

    .loading {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
    }

    .loading sl-spinner {
        font-size: 6em;
        --track-width: 10px;
        --speed: 2s;
        --indicator-color: var(--accent-color);
        --track-color: lightgray;
    }

    sl-icon-button {
        color: white;
    }

    @media only screen and (max-width: 600px) {
        .description {
            border-left: none;
        }

        .attribution-container {
            flex-direction: column;
            align-items: flex-start;
        }
    }
`;
